export default {
  computed: {
    nombre: {
      get() {
        return this.$store.state.clientes.NuevoCliente.nombre;
      },
      set(val) {
        return this.$store.commit("clientes/NuevoCliente/setNombre", val);
      },
    },
    apellido: {
      get() {
        return this.$store.state.clientes.NuevoCliente.apellido;
      },
      set(val) {
        return this.$store.commit("clientes/NuevoCliente/setApellido", val);
      },
    },
    nombreWeb: {
      get() {
        return this.$store.state.clientes.NuevoCliente.nombreWeb;
      },
      set(val) {
        return this.$store.commit("clientes/NuevoCliente/setNombreWeb", val);
      },
    },
    telCelular: {
      get() {
        return this.$store.state.clientes.NuevoCliente.telCelular;
      },
      set(val) {
        return this.$store.commit("clientes/NuevoCliente/setTelCelular", val);
      },
    },
    emailFacturacion: {
      get() {
        return this.$store.state.clientes.NuevoCliente.emailFacturacion;
      },
      set(val) {
        return this.$store.commit(
          "clientes/NuevoCliente/setEmailFacturacion",
          val,
        );
      },
    },
    emailGerencia: {
      get() {
        return this.$store.state.clientes.NuevoCliente.emailGerencia;
      },
      set(val) {
        return this.$store.commit(
          "clientes/NuevoCliente/setEmailGerencia",
          val,
        );
      },
    },
    usuario: {
      get() {
        return this.$store.state.clientes.NuevoCliente.nombreUsuario;
      },
      set(val) {
        return this.$store.commit(
          "clientes/NuevoCliente/setNombreUsuario",
          val,
        );
      },
    },
    password: {
      get() {
        return this.$store.state.clientes.NuevoCliente.password;
      },
      set(val) {
        return this.$store.commit("clientes/NuevoCliente/setPassword", val);
      },
    },
    cobranzas: {
      get() {
        return this.$store.state.clientes.NuevoCliente.cobranzas;
      },
      set(val) {
        return this.$store.commit("clientes/NuevoCliente/setCobranzas", val);
      },
    },
  },
};
